import {
  ComponentPropsWithoutRef,
  ElementRef,
  forwardRef,
  ReactNode,
} from 'react';

type RadioRowContainerElement = ElementRef<'div'>;
interface RadioRowContainerProps extends ComponentPropsWithoutRef<'div'> {
  label: ReactNode;
}

// eslint-disable-next-line react-x/no-forward-ref -- TODO: Wait! Don't change this file without seeing if you can remove this disable. It was added during a bulk version update, but fixing it would leave the park nicer than you found it.
const RadioRowContainer = forwardRef<
  RadioRowContainerElement,
  RadioRowContainerProps
>(({ children, label }, forwardedRef) => {
  return (
    <fieldset>
      <legend className="sr-only">{label}</legend>
      <div
        className="divide-grey-200 divide-y overflow-hidden rounded-lg bg-white"
        ref={forwardedRef}
      >
        {children}
      </div>
    </fieldset>
  );
});

RadioRowContainer.displayName = 'RadioRowContainer';

export { RadioRowContainer };
